import { z } from "zod";

/** Only the close is plotted, but a bar without a timestamp cannot be ordered. */
export const intradayBarSchema = z.object({
  t: z.string(),
  c: z.number(),
});

export const intradayBarsResponseSchema = z.object({
  bars: z.record(z.string(), z.array(intradayBarSchema).nullish()).nullish(),
  next_page_token: z.string().nullish(),
});

export type IntradayBar = z.infer<typeof intradayBarSchema>;
export type IntradayBarsResponse = z.infer<typeof intradayBarsResponseSchema>;
